import { render, staticRenderFns } from "./VolunteerPoolsNet.vue?vue&type=template&id=0a0255c7"
import script from "./VolunteerPoolsNet.vue?vue&type=script&lang=ts"
export * from "./VolunteerPoolsNet.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerPoolsNet.vue?vue&type=style&index=0&id=0a0255c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports